<template>
  <v-dialog
    v-model="dialog"
    persistent
    fullscreen
  >
    <!-- <template v-slot:activator="{ props }">
      <div v-bind="props" data-cy="podFiles-tree-actions-viewAsset-activator">
        <slot />
      </div>
    </template> -->

    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span>{{ $t('routes.pod.viewAssetDialogTitle') }}</span>
        <v-btn icon @click="closeDialog()" :aria-label="$t('common.close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="scrollable pb-0" style="min-height: calc(100vh - 110px); overflow: auto;">
        <div v-if="isPdf">
          <VuePdfEmbed id="view-asset-dialog-pdfEmbed" annotation-layer text-layer :source="asset.url" />
        </div>
        <div v-if="isDocx">
          <DocxFilePreview :url="asset.url" />
        </div>

        <div v-if="isDoc">
          <v-alert variant="tonal" density="compact" icon="mdi-information-outline">
            {{ $t('routes.pod.docPreviewNotSupported') }}
          </v-alert>
        </div>

        <div v-if="errorMessage" class="bg-error" data-cy="dialog-viewAsset-error">
          {{ errorMessage }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn color="primary" type="submit" variant="flat" data-cy="dialog-viewAsset-ok">
          {{ $t('common.close') }}
        </v-btn> -->
        <v-btn variant="text" @click="closeDialog()" data-cy="dialog-viewAsset-false">
          {{ $t('common.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

// import { usePodStore } from '@/stores/PodStore.js';
import MimetypeHelper from '@/components/MimetypeHelper.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';
import DocxFilePreview from '../DocxFilePreview.vue';

import VuePdfEmbed from 'vue-pdf-embed'
import 'vue-pdf-embed/dist/styles/annotationLayer.css'
import 'vue-pdf-embed/dist/styles/textLayer.css'

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "ViewAssetDialog",
  components: {
    VuePdfEmbed,
    DocxFilePreview,
  },
  props: {
    pod: {
      type: Object,
      required: true,
    },
    asset: {
      type: Object,
      required: true,
    }
  },
  data: function() {
    return {
      errorMessage: "",

      file: null,
    };
  },
  mounted() {
    // this.getFileContent();
  },
  watch: {
    dialog: function(newValue) {
      if (newValue) {
        this.errorMessage = "";
      }
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
  },
  computed: {
    isPdf() {
      return MimetypeHelper.isPdfAsset(this.asset);
    },
    isDocx() {
      return MimetypeHelper.isDocxAsset(this.asset);
    },
    isDoc() {
      return MimetypeHelper.isDocAsset(this.asset);
    },
    // isXls() {
    //   return helper.isXlsx(this.asset.mimetype);
    // }
  }
}
</script>

<style>
#view-asset-dialog-pdfEmbed > div {
  margin-bottom: 20px !important;
}
</style>
